const DATE_TIME_24_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

const FULL_DATE_TIME_24_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: "medium",
  timeStyle: "short",
  hour12: false,
};

const TIME_24_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

export function formatBlackspaceDateTime(value?: string | number | Date | null, fallback = "") {
  if (value === undefined || value === null || value === "") return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat(undefined, DATE_TIME_24_OPTIONS).format(date);
}

export function formatBlackspaceFullDateTime(value?: string | number | Date | null, fallback = "") {
  if (value === undefined || value === null || value === "") return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat(undefined, FULL_DATE_TIME_24_OPTIONS).format(date);
}

export function formatBlackspaceTime(value?: string | number | Date | null, fallback = "") {
  if (value === undefined || value === null || value === "") return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat(undefined, TIME_24_OPTIONS).format(date);
}
